import type { ReactNode } from 'react';
import type { AccountConfigDialogProps } from './components/AccountConfigDialog';
import type * as lazyIndex from './lazyIndex';
import { createLazyComponent, LazyAction, type LazyComponent, LazyModule } from 'owa-bundling';
import type { AddAccountDialogProps } from './types/AddAccountDialogProps';

export {
    accountAddedFromAccountConfigDialog,
    type AccountAddedFromAccountConfigDialogActionMessage,
} from './actions/accountAddedFromAccountConfigDialog';
export {
    accountConfigDialogClosed,
    type AccountConfigDialogClosedActionMessage,
} from './actions/accountConfigDialogClosed';

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule(
    () => import(/* webpackChunkName: "AccountConfig" */ './lazyIndex'),
    { name: 'AccountConfig' }
);

// Account configuration entrypoints
export const AccountConfig: LazyComponent<AccountConfigDialogProps, unknown, void> =
    createLazyComponent(lazyModule, m => m.AccountConfiguration);
export const AddAccountDialog: LazyComponent<AddAccountDialogProps, unknown, void> =
    createLazyComponent(lazyModule, m => m.AddAccountDialog);

// Proxies
export const lazyAuthAccount: LazyAction<typeof lazyIndex.authAccountProxy, typeof lazyModule> =
    new LazyAction(lazyModule, m => m.authAccountProxy);
export const lazySetAuthAccountResult: LazyAction<
    typeof lazyIndex.setAuthAccountResultProxy,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.setAuthAccountResultProxy);
export const InlineContainer: LazyComponent<
    {
        children?: ReactNode | undefined;
    },
    unknown,
    void
> = createLazyComponent(lazyModule, m => m.InlineContainerProxy);
